import ReactECharts from "echarts-for-react";
import { useRef } from "react";
import { AppCard } from "@/layout/AppComponents";

const Report25OnlineInfo = ({ responseData }) => {
  const chartRef = useRef(null);

  const generateColors = (array) => {
    return array.map((_, index) => {
      const hue = (360 * index) / array.length;

      return `hsl(${hue}, 70%, 50%)`;
    });
  };

  return (
    <div className="row  mt-3">
      <div className="col-xl-12">
        <AppCard>
          <div
            style={{
              width: "80%",
              height: "900px",
              margin: "auto",
            }}
          >
            <ReactECharts
              style={{ width: "100%", height: "100%" }}
              onChartReady={(chart) => {
                chartRef.current = chart;
                chart.resize();
              }}
              option={{
                xAxis: {
                  type: "value",
                  name: "MI",
                  nameLocation: "middle",
                  splitLine: { show: false },
                  min: 0,
                  max: 100,
                },
                yAxis: {
                  type: "value",
                  name: "CI",
                  nameLocation: "middle",
                  splitLine: { show: false },
                  scale: true,
                  min: 0,
                  max: 100,
                },
                series: [
                  {
                    name: "1990",
                    data: responseData?.onlineInfo,
                    type: "scatter",
                    itemStyle: {
                      color: (params) =>
                        generateColors(responseData?.onlineInfo)[params.dataIndex],
                    },
                    symbolSize: (data) => data[2],
                    emphasis: {
                      focus: "self",
                    },
                    labelLayout: () => ({
                      x: chartRef.current?.getWidth() - 100,
                      moveOverlap: "shiftY",
                    }),
                    labelLine: {
                      show: true,
                      length2: 5,
                      lineStyle: {
                        color: "#bbb",
                      },
                    },
                    label: {
                      show: true,
                      formatter: function (param) {
                        return param.data[3];
                      },
                      position: "right",
                      minMargin: 2,
                    },
                  },
                ],
              }}
            />
          </div>
        </AppCard>
      </div>
    </div>
  );
};

export default Report25OnlineInfo;
